import moment from 'moment';
import {
    BigNumber,
} from 'bignumber.js';
import Orders from '@/utils/orders';
import MaskView from '@/components/common/MaskView.vue';
import Dialog from '@/components/common/Dialog.vue';
import Footer from '@/components/common/Footer';
import Confirm from '@/components/common/Confirm.vue';

export default {
    name: 'Orders',
    components: {
        MaskView,
        Dialog,
        Footer,
        Confirm,
    },
    data() {
        return {
            /**
             * @Search
             */
            serachMainMarket: '',
            availableList: [],
            selectMarketId: 0,
            startDate: '',
            endDate: '',
            force: false,
            // -----------Mask-------
            /**
             * @maskStatus
             */
            maskStatus: false,
            // ------------Mask End-------
            // -----------Dialog-------
            /**
             * @dialog 0 hide 1 show
             * @btnStatus type of dialog
             */
            dialog: 0,
            btnStatus: '',
            warningMsg: {},

            // ------------Dialog End-------
            // ----------- Status ----------
            /**
             * @status
             * @openOrders
             * @orderHistory
             * @deals
             */
            orderStatus: 'openOrders',
            // ----------- Order List ----------

            orderList: [],
            // ----------- page ----------
            pageNo: 0,
            pageLength: 0,
            nomore: false,
            nomoreTips: false,
            limit: 10,
            confirmStatus: false,
            currOrderInfo: {},
            supportMarket: [],
        };
    },
    mounted() {
        if (!this.$store.getters.currAccount) {
            return this.$router.push('/Register');
        }
        return this.getOrders();
    },
    watch: {
        currAccountIndex(n, o) {
            const self = this;
            if (n !== o) {
                self.userId = self.$store.state.accountList[n].userid;
                self.getOrders(self.orderStatus);
            }
        },
    },
    computed: {
        currAccountIndex() {
            return this.$store.state.currAccountIndex;
        },
        currIndex() {
            return this.$store.state.currAccountIndex;
        },
    },
    methods: {
        searchChange() {
            const self = this;
            self.dynamicSelectOptions(self.serachMainMarket);
        },
        dynamicSelectOptions(st) {
            const self = this;
            const availableList = [];
            const allMarkets = self.supportMarket;
            allMarkets.forEach((v) => {
                const main = v.name.split('/')[0];
                const tar = v.name.split('/')[1];
                if (main.indexOf(st) >= 0) {
                    availableList.push({
                        options: tar,
                        value: v.id,
                    });
                }
            });
            self.availableList = availableList;
        },
        showConfirmDialog(orderInfo) {
            const self = this;
            self.currOrderInfo = orderInfo;
            if (window.password && window.password[self.$store.getters.currAccount.userid]) {
                return self.callCancelOrder({
                    password: window.password[self.$store.getters.currAccount.userid],
                });
            }
            self.maskStatus = true;
            self.confirmStatus = true;
            return null;
        },
        hideMaskView() {
            const self = this;
            self.maskStatus = false;
            self.confirmStatus = false;
        },

        searchOrder() {
            const self = this;
            // const startDate = self.startDate;
            // const endDate = self.endDate;
            const marketId = self.selectMarketId;
            self.force = true;
            self.getOrders(0, marketId, 10);
        },
        callCancelOrder(res) {
            const self = this;
            self.maskStatus = false;
            self.confirmStatus = false;
            const accountInfo = self.$store.getters.currAccount;
            Orders.cancelOrders(
                accountInfo,
                accountInfo.userid,
                self.currOrderInfo,
                res.password,
            ).then((resp) => {
                if (resp.code === 0) {
                    self.$Message.success(self.$t('trade_cancel_order_success'));
                    setTimeout(() => {
                        self.getOrders();
                    }, 5000);
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        changeStatus(st) {
            const self = this;
            const status = st;
            self.orderStatus = status;
            self.orderList = [];
            self.pageNo = 0;
            self.getOrders();
        },

        getOrders(o = 0, m = '', limit = 10) {
            const self = this;
            const type = self.orderStatus;
            const AccountList = self.$store.state.accountList;
            const currAccountIndex = self.$store.state.currAccountIndex;
            const currUser = AccountList[currAccountIndex].userid;
            let startDate;
            let endDate;
            const f = self.force;
            if (
                f === 'force' &&
                self.startDate &&
                self.endDate &&
                self.selectMarketId
            ) {
                startDate = Date.now(self.startDate);
                endDate = Date.now(self.endData);
                // eslint-disable-next-line no-param-reassign
                m = self.selectMarketId;
            }
            // TODO
            // currUser = 'binance12345';
            Orders.getOrderList(type, currUser, o, m, limit, startDate, endDate).then(
                (res) => {
                    if (res.result.length === 0) {
                        if (self.pageNo === 0) {
                            // changeStatust = [];
                            self.nomore = true;
                            return;
                        }
                        self.nomore = true;
                    } else if (res.result.length < self.limit) {
                        self.renderOrders(res.result);
                        self.nomore = true;
                        self.nomoreTips = false;
                    } else {
                        self.renderOrders(res.result);
                    }
                },
            );
        },
        prevPage() {
            const self = this;
            let currPage = self.pageNo;
            currPage -= 1;
            self.pageNo = currPage;
            self.getOrders((currPage * 10) - 1, '', self.limit);
        },
        nextPage() {
            const self = this;
            let currPage = self.pageNo;
            currPage += 1;
            self.pageNo = currPage;
            self.getOrders((currPage * 10) - 1, '', self.limit);
        },
        renderOrders(data) {
            const self = this;
            const renderData = data;
            renderData.forEach((v) => {
                /**
                 * @side == sell fee = market.split("/")[1]
                 * @side == buy fee = market.split("/")[0]
                 * @total = price * amount
                 * @price = market.split("/")[1]
                 * @amount = market.split("/")[0]
                 */
                // TODO
                let time;
                // constmoment(v.createTime * 1000).format('YYYY-MM-DD hh:mm:ss');
                const priceMarket = v.market.split('/')[1];
                const amountMarket = v.market.split('/')[0];
                let feeMarket;
                let filled;
                if (v.side === 'SELL') {
                    feeMarket = v.market.split('/')[1];
                } else if (v.side === 'BUY') {
                    feeMarket = v.market.split('/')[0];
                }
                const price = new BigNumber(v.price);
                const amount = new BigNumber(v.type === 'MARKET' ? v.dealMoney : v.amount);
                let left = new BigNumber(v.left);
                if (this.orderStatus === 'finishedOrders' && v.type === 'MARKET') {
                    left = 0;
                }

                const already = amount.minus(left);
                const percent = new BigNumber(100);
                if (v.stock === v.amount) {
                    filled = 100;
                } else {
                    filled = already
                        .div(amount)
                        .times(percent)
                        .toFixed(0);
                    if (isNaN(filled)) {
                        filled = 0;
                    }
                }
                filled = parseInt(filled);
                if (self.orderStatus === 'userDeals') {
                    time = moment(v.time * 1000).format('YYYY-MM-DD HH:mm:ss');
                    filled = 100;
                } else {
                    time = moment(v.createTime * 1000).format('YYYY-MM-DD HH:mm:ss');
                }
                if (filled > 99.8) {
                    filled = 100;
                }
                if (this.orderStatus != 'openOrders') {
                   // filled = 100;
                }
                const paTotal = price
                    .times(amount).toFixed();
                Object.assign(v, {
                    time,
                    paTotal,
                    filled,
                    priceMarket,
                    amountMarket,
                    feeMarket,
                });
            });
            self.nomore = false;
            self.orderList = renderData;
        },
        showDialog(eventId) {
            const self = this;
            if (eventId) {
                self.btnStatus = eventId;
                self.warningMsg = self.warningMsgBackup[eventId];
                self.maskStatus = 1;
                self.dialog = 1;
            }
        },
        hideDialog() {
            const self = this;
            self.warningMsg = {};
            self.maskStatus = 0;
            self.dialog = 0;
        },
    },
};



// WEBPACK FOOTER //
// ./src/views/order.js